/**
 * 中转站
 * 两页面相互调用方法
 */
import Vue from 'vue'

export default new Vue()
